// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.home-section {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  height: 85vh;
  background-color: #000000;
  padding-right: 0;
  padding-bottom: 0;
  color: #fff;
  position: relative;
}

.text-content {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding-left: 90px;
  color: white;
  animation: slideInTop 1.5s ease-out;
}

.home-section h1 {
  margin: 0;
  padding: 10px 0px 10px 0px;
  font-size: 48px;
  color: white;
}

.download-btn {
  background-color: #e74c3c;
  font-size: 23px;
  color: #fff;
  border: none;
  padding: 15px 20px;
  cursor: pointer;
  margin-top: 20px;
  max-width: 200px;
}

.image-content {
  flex: 1 1;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  animation: slideInTop 1.5s ease-out;
}

.home-image {
  padding-right: 100px;
  width: auto;
  max-height: 85vh;
  object-fit: cover;
  filter: brightness(0.4);
}

@keyframes slideInTop {
  from {
    opacity: 0;
    transform: translateY(-100%);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@media (max-width: 1100px) {
  .text-content {
    padding-left: 30px;
  }
  .home-section h1 {
    font-size: 30px;
    color: white;
  }
  .download-btn {
    font-size: 18px;
    padding: 15px 20px;
  }
  .home-image {
    padding-right: 30px;
  }
}

@media (max-width: 480px) {
  .home-section {
    display: grid;
    grid-template-rows: auto 1fr;
    min-height: 75vh;
  }
  .text-content {
    padding: 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
    grid-row: 1;
    margin-top: 80px;
    margin-bottom: 0;
    padding-bottom: 0;
  }
  .home-section h1 {
    font-size: 24px;
  }
  .download-btn {
    font-size: 16px;
    padding: 10px;
    max-width: 150px;
  }
  .image-content {
    display: flex;
    justify-content: center;
    align-items: flex-end;
    grid-row: 2;
    padding-bottom: 0;
    overflow: hidden;
  }
  .home-image {
    padding: 0;
    max-width: 80%;
    height: auto;
    object-fit: contain;
    object-position: center;
  }
  .home-section {
    height: auto;
  }
  .image-content {
    align-self: end;
  }
}
`, "",{"version":3,"sources":["webpack://./src/Components/Home.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,8BAA8B;EAC9B,YAAY;EACZ,yBAAyB;EACzB,gBAAgB;EAChB,iBAAiB;EACjB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,kBAAkB;EAClB,YAAY;EACZ,mCAAmC;AACrC;;AAEA;EACE,SAAS;EACT,0BAA0B;EAC1B,eAAe;EACf,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,eAAe;EACf,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,mCAAmC;AACrC;;AAEA;EACE,oBAAoB;EACpB,WAAW;EACX,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;EACE;IACE,UAAU;IACV,4BAA4B;EAC9B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,kBAAkB;EACpB;EACA;IACE,eAAe;IACf,YAAY;EACd;EACA;IACE,eAAe;IACf,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,aAAa;IACb,4BAA4B;IAC5B,gBAAgB;EAClB;EACA;IACE,UAAU;IACV,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,WAAW;IACX,gBAAgB;IAChB,gBAAgB;IAChB,iBAAiB;EACnB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;IACf,aAAa;IACb,gBAAgB;EAClB;EACA;IACE,aAAa;IACb,uBAAuB;IACvB,qBAAqB;IACrB,WAAW;IACX,iBAAiB;IACjB,gBAAgB;EAClB;EACA;IACE,UAAU;IACV,cAAc;IACd,YAAY;IACZ,mBAAmB;IACnB,uBAAuB;EACzB;EACA;IACE,YAAY;EACd;EACA;IACE,eAAe;EACjB;AACF","sourcesContent":[".home-section {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: space-between;\n  height: 85vh;\n  background-color: #000000;\n  padding-right: 0;\n  padding-bottom: 0;\n  color: #fff;\n  position: relative;\n}\n\n.text-content {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  padding-left: 90px;\n  color: white;\n  animation: slideInTop 1.5s ease-out;\n}\n\n.home-section h1 {\n  margin: 0;\n  padding: 10px 0px 10px 0px;\n  font-size: 48px;\n  color: white;\n}\n\n.download-btn {\n  background-color: #e74c3c;\n  font-size: 23px;\n  color: #fff;\n  border: none;\n  padding: 15px 20px;\n  cursor: pointer;\n  margin-top: 20px;\n  max-width: 200px;\n}\n\n.image-content {\n  flex: 1;\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n  animation: slideInTop 1.5s ease-out;\n}\n\n.home-image {\n  padding-right: 100px;\n  width: auto;\n  max-height: 85vh;\n  object-fit: cover;\n  filter: brightness(0.4);\n}\n\n@keyframes slideInTop {\n  from {\n    opacity: 0;\n    transform: translateY(-100%);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n@media (max-width: 1100px) {\n  .text-content {\n    padding-left: 30px;\n  }\n  .home-section h1 {\n    font-size: 30px;\n    color: white;\n  }\n  .download-btn {\n    font-size: 18px;\n    padding: 15px 20px;\n  }\n  .home-image {\n    padding-right: 30px;\n  }\n}\n\n@media (max-width: 480px) {\n  .home-section {\n    display: grid;\n    grid-template-rows: auto 1fr;\n    min-height: 75vh;\n  }\n  .text-content {\n    padding: 0;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    text-align: center;\n    grid-row: 1;\n    margin-top: 80px;\n    margin-bottom: 0;\n    padding-bottom: 0;\n  }\n  .home-section h1 {\n    font-size: 24px;\n  }\n  .download-btn {\n    font-size: 16px;\n    padding: 10px;\n    max-width: 150px;\n  }\n  .image-content {\n    display: flex;\n    justify-content: center;\n    align-items: flex-end;\n    grid-row: 2;\n    padding-bottom: 0;\n    overflow: hidden;\n  }\n  .home-image {\n    padding: 0;\n    max-width: 80%;\n    height: auto;\n    object-fit: contain;\n    object-position: center;\n  }\n  .home-section {\n    height: auto;\n  }\n  .image-content {\n    align-self: end;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
